module.exports = __webpack_public_path__ + "img/star.daaf2ee9.png";